import objectFitImages from 'object-fit-images';
import 'lazysizes';
import 'lazysizes/plugins/noscript/ls.noscript';
import iFrameResize from 'iframe-resizer/js/iframeResizer'; // https://github.com/davidjbradshaw/iframe-resizer
import 'picturefill'; // https://github.com/scottjehl/picturefill
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';
import LinkFocusHelper from './components/00_utilities/helpers/LinkFocusHelper';

/**
 *  SF Cookie Consent
 *
 */
import Consent from './components/vendor/sfcookieconsent';

const componentHelper = new ComponentHelper();

/* eslint-disable */
const __svg__ = { path: './svg/*.svg', name: 'Icons/icons.svg', filename: svgFileName };
require('webpack-svgstore-plugin/src/helpers/svgxhr')(__svg__);

if (__devMode__) {
    __webpack_public_path__ = 'http://localhost:8085/typo3conf/ext/sfsitepackage/Resources/Public/';
}

// link focus
// fix for problem described here https://axesslab.com/skip-links/
// taken from https://github.com/selfthinker/dokuwiki_template_writr/blob/master/js/skip-link-focus-fix.js
jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector){
        const $element = $(el);
        return $element.is(':input:enabled, a[href], area[href], object, [tabindex]') && !$element.is(':hidden');
    }
});

LinkFocusHelper.handleHashLink();

// readspeaker
if (! window.rsConf) { window.rsConf = {}; }
if (! window.rsConf.ui) { window.rsConf.ui = {}; }
if (! window.rsConf.general) { window.rsConf.general = {}; }
window.rsConf = {
    general: {
        usePost: true
    }
};

$(window).on('load', () => {
    componentHelper.initializePage();

    objectFitImages();

    // http://jira.schalk-office.de:8080/browse/SFR-83
    // https://github.com/davidjbradshaw/iframe-resizer
    iFrameResize({
        log: true,
        scrolling: true
    });

    // readspeaker
    window.rsConf = {
        general: {
            usePost: true
        }
    };

    window.rsDocReaderConf = {
        lang: 'de_de',
        cid: 'caogi',
        drBeforeLink: true,
        img_alt: document.querySelector('header').getAttribute('data-readspeaker-img-alt'),
    };
});

// alt and title attrs remove, on readspeaker clicked
$(document).ready(() => {
    $('#readspeaker_button1, #readspeaker_button1 a, #readspeaker_button1 a span').on('click', () => {
        $('#webmaincontent img, #webmaincontent a').each((i, e) => {
            e.title = ''
            e.alt = ''
            $(this).attr('title','').attr('alt','');
        });
    });
});

/**
 *  Initialize Cookie Consent
 */
Consent.init();

/**
 * Check for hot module replacement and use it if possible
 */
if (module.hot) {
    module.hot.accept();
}
